import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FechamentoFinanceiroService } from '../../../../../shared/services/apis/financas/fechamento-financeiro.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { MaskService } from '../../../../../shared/services/mask.service';

@Component({
    selector: 'app-modal-fechamento-financeiro',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
    ],
    templateUrl: './modal-fechamento-financeiro.component.html',
    styleUrls: ['./modal-fechamento-financeiro.component.css'],
})
export class ModalFechamentoFinanceiroComponent implements OnInit {
    public dataCtrl = new FormControl<Date | null>(null);
    public _isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<ModalFechamentoFinanceiroComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { dataFechamento: Date | null },
        private fechamentoService: FechamentoFinanceiroService,
        private alertService: AlertService,
    ) { }

    ngOnInit(): void {
        if (this.data.dataFechamento) {
            this.dataCtrl.setValue(new Date(this.data.dataFechamento));
        }
    }

    public onDateInput(event: Event): void {
        MaskService.onDateInput(event, this.dataCtrl);
    }

    public salvar(): void {
        const dataFechamento = this.dataCtrl.value;
        if (!dataFechamento) return;

        this._isLoading = true;
        this.dataCtrl.disable();
        this.fechamentoService.save(dataFechamento.toISOString()).subscribe({
            next: (response) => {
                this._isLoading = false;
                this.dataCtrl.enable();
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao salvar fechamento.', AlertType.error);
                    return;
                }
                this.dialogRef.close({ dataFechamento });
            },
            error: () => {
                this._isLoading = false;
                this.dataCtrl.enable();
                this.alertService.show('Erro', 'Não foi possível salvar o fechamento.', AlertType.error);
            },
        });
    }

    public removerFechamento(): void {
        this._isLoading = true;
        this.dataCtrl.disable();
        this.fechamentoService.delete().subscribe({
            next: (response) => {
                this._isLoading = false;
                this.dataCtrl.enable();
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao remover fechamento.', AlertType.error);
                    return;
                }
                this.dialogRef.close({ dataFechamento: null });
            },
            error: () => {
                this._isLoading = false;
                this.dataCtrl.enable();
                this.alertService.show('Erro', 'Não foi possível remover o fechamento.', AlertType.error);
            },
        });
    }
}
